import { useState, useEffect } from 'react';
import './Alumni.css';
import alumniPic1 from '../alumni/alumni (1).webp'
import alumniPic2 from '../alumni/alumni (2).webp'
import alumniPic3 from '../alumni/alumni (3).webp'
import alumniPic4 from '../alumni/alumni (4).webp'
import alumniPic5 from '../alumni/alumni (5).webp'
import alumniPic6 from '../alumni/alumni (6).webp'
import alumniPic7 from '../alumni/alumni (7).webp'
import alumniPic8 from '../alumni/alumni (8).webp'
import alumniPic9 from '../alumni/alumni (9).webp'
import alumniPic10 from '../alumni/alumni (10).webp'
import alumniPic11 from '../alumni/alumni (11).webp'
import alumniPic12 from '../alumni/alumni (12).webp'
import alumniPic13 from '../alumni/alumni (13).webp'
import alumniPic14 from '../alumni/alumni (14).webp'
import alumniPic15 from '../alumni/alumni (15).webp'
import alumniPic16 from '../alumni/alumni (16).webp'
import alumniPic17 from '../alumni/alumni (17).webp'
import alumniPic18 from '../alumni/alumni (18).webp'
import alumniPic19 from '../alumni/alumni (19).webp'
import alumniPic20 from '../alumni/alumni (20).webp'
import alumniPic21 from '../alumni/alumni (21).webp'
import alumniPic22 from '../alumni/alumni (22).webp'
import alumniPic23 from '../alumni/alumni (23).webp'
import alumniPic24 from '../alumni/alumni (24).webp'
import alumniPic25 from '../alumni/manav suthar.jpeg'

const AlumniPage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // Gallery images for Session 2024-25
  const galleryImages = [
    { id: 25, src: alumniPic25, alt: 'Alumni Event 25' },
    { id: 4, src: alumniPic4, alt: 'Alumni Event 4' }, 
    { id: 6, src: alumniPic6, alt: 'Alumni Event 6' },
    { id: 2, src: alumniPic2, alt: 'Alumni Event 2' },
    { id: 3, src: alumniPic3, alt: 'Alumni Event 3' }, 
    { id: 5, src: alumniPic5, alt: 'Alumni Event 5' }, 
    { id: 7, src: alumniPic7, alt: 'Alumni Event 7' },
    { id: 21, src: alumniPic21, alt: 'Alumni Event 21' },
    { id: 18, src: alumniPic18, alt: 'Alumni Event 18' },
    { id: 19, src: alumniPic19, alt: 'Alumni Event 19' },
    { id: 20, src: alumniPic20, alt: 'Alumni Event 20' },
    { id: 22, src: alumniPic22, alt: 'Alumni Event 22' },
    { id: 23, src: alumniPic23, alt: 'Alumni Event 23' },
    { id: 24, src: alumniPic24, alt: 'Alumni Event 24' },
    { id: 8, src: alumniPic8, alt: 'Alumni Event 8' },
    { id: 9, src: alumniPic9, alt: 'Alumni Event 9' },
    { id: 14, src: alumniPic14, alt: 'Alumni Event 14' },
    { id: 17, src: alumniPic17, alt: 'Alumni Event 17' },
    { id: 10, src: alumniPic10, alt: 'Alumni Event 10' },
    { id: 11, src: alumniPic11, alt: 'Alumni Event 11' },
    { id: 12, src: alumniPic12, alt: 'Alumni Event 12' },
    { id: 13, src: alumniPic13, alt: 'Alumni Event 13' },
    { id: 15, src: alumniPic15, alt: 'Alumni Event 15' },
    { id: 16, src: alumniPic16, alt: 'Alumni Event 16' },
    { id: 1, src: alumniPic1, alt: 'Alumni Event 1' },
    
    
  ];

  useEffect(() => {
    setAllImages(galleryImages);
  }, []);

  const handleImageClick = (imageSrc) => {
    const imageIndex = galleryImages.findIndex(image => image.src === imageSrc);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex === null) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex]);

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>ALUMNI FACILATION</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Alumni Facilation</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="alumni-container">
        {/* Title Section */}
        <div className="alumni-title-section">
          <h2>ALUMNI FACILATION</h2>
          <div className="alumni-title-underline"></div>
        </div>

        {/* Session Gallery */}
        <section className="alumni-gallery-section">
          
          <div className="alumni-gallery">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id} 
                className={`alumni-gallery-item ${index % 2 === 0 ? 'alumni-left' : 'alumni-right'}`}
                onClick={() => handleImageClick(image.src)}
              >
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {currentImageIndex !== null && (
        <div className="alumni-modal show" onClick={(e) => {
          if (e.target.classList.contains('alumni-modal')) {
            closeModal();
          }
        }}>
          <div className="alumni-modal-wrapper">
            <button className="alumni-modal-close" onClick={closeModal}>&times;</button>
            <button className="alumni-modal-btn alumni-modal-prev" onClick={prevImage}>❮</button>
            <img 
              className="alumni-modal-image" 
              src={galleryImages[currentImageIndex].src} 
              alt={galleryImages[currentImageIndex].alt}
            />
            <button className="alumni-modal-btn alumni-modal-next" onClick={nextImage}>❯</button>
          </div>
        </div>
      )}
    </>
  );
};

export default AlumniPage;